import React, { useEffect, useState } from "react";
import { Apis } from "../help/Apis";
import BackdropScI from "../services/BackdropScI";
import SignIn from "./SignIn";
import Main from "../Fronts/Main/Main";
import Endemam from "./Endemam";
import ReConnect from "./ReConnect";
import Accsept from "./Accsept";
import { useLocation } from "react-router";
import { getLS } from "../utils/useLS";
import axios from "axios";
import MainScreen from "../Fronts/Main/MainScreen";

export default function Bigen() {
  const location = useLocation();
  const [ViewT, setViewT] = useState(null);
  const [load, setLoad] = useState(true);
  const play = (isok, fp, leav, load) => {
    if (leav == "main") {
      if (isok == true) {
        if (fp == 0) setViewT(ToMain());
        else if (fp == 1) setViewT(ToMain());
        // else if (fp == 1) setViewT(ToRePay());
      } else if (isok == false) setViewT(ToReConnect());
    }
    if (leav == "endemam") {
      console.log("endemam");
      setViewT(ToEndemam());
    } else if (leav == "accsept" || leav == "undefined") {
      console.log("accsept 22");
      setViewT(ToAccsept());
    } else if (leav == "signIn") {
      // console.log(isok+'')
      console.log("signIn");
      if (isok == true) setViewT(ToSignIn());
      else if (isok == false) setViewT(ToReConnect());
    }

    // alert('load')
    setLoad(load);
  };

  useEffect(async () => {
    console.log("useEffect Bigen");

    const uris = Apis();
    let loc = getLS("infoConn", { useUri: false, leavle: "undefined" });
    console.log("___loc___");
    console.log(loc);
    console.log("___loc___");
    //  alert(loc.useUri+'');
    play(true, 0, loc.leavle, false);
  }, [location.key]);
  return load ? <BackdropScI /> : <div> {ViewT} </div>;
}

const ToEndemam = () => {
  return <Endemam />;
};
const ToMain = () => {
  return <MainScreen />;
  // return <Main />;
};
const ToSignIn = () => {
  return <SignIn />;
};
const ToReConnect = () => {
  return <ReConnect />;
};
const ToAccsept = () => {
  return <Accsept />;
};
